import { render, staticRenderFns } from "./user-messages.vue?vue&type=template&id=030e51d0&scoped=true"
import script from "./user-messages.vue?vue&type=script&lang=js"
export * from "./user-messages.vue?vue&type=script&lang=js"
import style0 from "./user-messages.vue?vue&type=style&index=0&id=030e51d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "030e51d0",
  null
  
)

export default component.exports